<template>
  <div id="app">
    <div id="main" uk-height-viewport="expand: true">
    <Menu></Menu>
    <transition
        name="fade"
        mode="out-in"
      >
    <router-view/>
  </transition>
</div>
  <Footer></Footer>
  </div>
</template>

<script>
import Menu from "@/components/Menu"
import Footer from "@/components/Footer"
import EventBus from "@/EventBus"

export default {
  data: () => ({
    isLoading: true
  }),
  mounted() {
    EventBus.$on("i18n-load-start", () => (this.isLoading = true))

    EventBus.$on("i18n-load-complete", () => (this.isLoading = false))
    this.setDocumentLang()
    this.setDocumentTitle()
  },
  name: 'App',
  components: {
    Menu, Footer
  },
  methods: {
    setDocumentTitle() {
      let title = this.$i18n.t('base.title')
      let pathName = this.$route.name.toLowerCase()
      let subtitle = this.$i18n.messages[this.$i18n.locale][pathName].title || this.$i18n.t('base.subtitle')
      document.title = title + ' - ' + subtitle
    },
    setDocumentLang() {
      document.documentElement.lang = this.$i18n.locale
    }
  },
  watch: {
    '$route' () {
      this.setDocumentTitle()
      this.setDocumentLang()
    }
  }
}
</script>


<style>
@font-face {
  font-display: swap;
  font-family: 'Bradford';
  src: url('./assets/fonts/BradfordLL-Regular.woff2') format('woff2'),
  url('./assets/fonts/BradfordLL-Regular.woff') format('woff'),
  url('./assets/fonts/BradfordLL-Regular.ttf')  format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-display: swap;
  font-family: 'Mier B';
  src: url('./assets/fonts/MierBDemiBold.woff2') format('woff2'),
      url('./assets/fonts/MierBDemiBold.woff') format('woff'),
      url('./assets/fonts/MierBDemiBold.ttf')  format('truetype');
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-display: swap;
  font-family: 'Mier B';
  src: url('./assets/fonts/MierBRegular.woff2') format('woff2'),
  url('./assets/fonts/MierBRegular.woff') format('woff'),
  url('./assets/fonts/MierBRegular.ttf')  format('truetype');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-display: swap;
  font-family: 'Mier B';
  src: url('./assets/fonts/MierBLight.woff2') format('woff2'),
  url('./assets/fonts/MierBLight.woff') format('woff'),
  url('./assets/fonts/MierBLight.ttf')  format('truetype');
  font-weight: 300;
  font-style: normal;
}

body {
  background-color:#F4F0E9;
  min-height:100vh;
}
#app {
  font-family: 'Bradford', Times, Helvetica, Arial, sans-serif;
  font-size:20px;
  color:#333;
  letter-spacing:.3px;
  line-height:30px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}
h1 {
  font-family: 'Mier B';
  font-size:36px;
  font-weight:400;
  padding-top:32px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
h2 {
  color:#333;
  font-family: 'Mier B';
  font-size:28px;
  font-weight:300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media (min-width: 960px) {

  h2.quote {
    font-size: calc(1.2vw + 20px);
    line-height: calc(1.8vw + 1);
    margin-bottom: 0px;
  }
}
@media (min-width: 1442px) {
  h2.quote {
    font-size: 48px;
  }
}
h3 {
  color: rgb(0, 0, 0, .9);
  font-family: 'Mier B';
  font-size:19px;
  font-weight:300;
  padding-top:24px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
p {
  margin: 0 0 24px 0;
}
.small-text {
  font-size:18px;
  color:rgb(0,0,0,.6);
}
.uk-flex h3 {
  margin-top:4px;
  margin-bottom:0;
  padding-bottom:0;
}
.uk-flex h3:first-of-type {
  margin-top:0;
  padding-top:0;
}
.quote-author {
  font-family: "Mier B";
  font-weight:300;
  font-size:22px;
  padding: 12px 0 48px 0;
}
a {
  color:#3CB49E;
}
a:hover {
  color:#3CB49E;
}
p.intro {
  font-family: "Mier B";
  padding-bottom:40px;
}
hr {
  border-top:1px solid rgb(0,0,0,.1);
}
.uk-grid h3 {
  padding-top:4px;
}
.uk-grid+.uk-grid, .uk-grid>.uk-grid-margin, *+.uk-grid-margin {
    margin-top: 48px;
}
.berenike-name {
  font-family: 'Mier B';
  font-size:24px;
}
.uk-navbar {
  height:80px;
}
.uk-navbar-container:not(.uk-navbar-transparent) {
  background: #F4F0E9;
}
.uk-navbar-nav>li>a {
  font-family: "Mier B";
  font-size:12px;
  font-weight:300;
  letter-spacing:2px;
  color:#333;
  height:80px;
}
@media only screen and (min-width: 640px) {
.uk-navbar-sticky {
  border-bottom:1px solid rgb(0,0,0,.07);
  height:45px;
}
.uk-navbar-sticky .uk-navbar-nav>li>a {
  height:45px;
}
.uk-navbar-sticky .uk-navbar-center .uk-logo img, .uk-navbar-sticky .uk-navbar-center a.uk-logo {
  display:none;
}
}
.uk-navbar-item, .uk-navbar-nav>li>a, .uk-navbar-toggle {
}
.uk-logo {
  height:100%;
}
.uk-logo img {
   height: 100%;
 }
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.8s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0
}
.uk-position-cover h1 {
  color:#fff;
}
.uk-input, .uk-textarea {
  color:#333;
  font-size:16px;
}
.footer-container {
  background: #EAE5DE;
  }
.footer {
  color:#333;
  font-size:16px;
  line-height:22px;
  margin-top:64px;
  padding-top:32px;
}
.uk-list {
  color: rgb(0,0,0,.65);
  font-size:14px;
  line-height:1.4
}
.nav-mobile {
  z-index:999;
  left:8px;
}
.nav-mobile a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
}
#offcanvas-nav a {
  color: rgb(255,255,255,.8);
  font-family:"Mier B";
  font-size:20px;
}
.uk-offcanvas-close {
  position: relative;
  top:0;
  right:0;
}
.uk-navbar-center-left, .uk-navbar-center-right {
  position: static;
}
.uk-offcanvas-bar-animation {
  transition: left .2s ease-out;
}
.locale-changer {
  color:#ccc;
  font-size: 16px;
  padding:16px 0 8px 0;
  z-index: 999;
}
.locale-changer a {
  color: rgb(0,0,0,0.4);
  display: inline-block;
  padding: 10px 6px;
  margin: -10px -6px;
}
#offcanvas-nav .locale-changer {
  margin-top: 24px;
  padding: 16px 0 0 0;
  border-top: 1px solid rgb(255,255,255,.2);
  color: rgb(255,255,255,.4);
}
#offcanvas-nav .locale-changer a {
  font-size: 16px;
  color: rgb(255,255,255,.8);
}
.divider-line {
  padding: 0 10px;
  width:10px;
  display: inline;
}
@media only screen and (max-width: 960px) {
  #app {
    font-size:18px;
    line-height:1.5;
  }
  h1 {
    font-size:32px;
  }
  h3 {
    font-size:20px;
  }
  h2.quote {
    margin-block-end: .4em;
  }
  .quote-author {
    padding: 0px 0 32px 0;
  }
  .uk-padding {
    padding: 18px;
  }
  .uk-height-large {
    height:260px;
  }
}
</style>
